import { classNames } from 'helpers'
import React from 'react'

interface ContainerProps {
  variant?: 'primary' | 'secondary' | 'tertiary' | 'quaternary'
  className?: string
}

const styles = {
  base: 'font-manrope',
  variant: {
    primary: 'max-w-8xl mx-auto',
    secondary: 'max-w-8xl mx-auto px-4 sm:px-6 lg:px-8',
    tertiary: 'container mx-auto sm:px-6 lg:px-8',
    quaternary: 'container mx-auto px-4 sm:px-6 lg:px-8',
  },
}

const Container: React.FC<ContainerProps> = ({
  variant = 'primary',
  children,
  className,
  ...args
}) => {
  return (
    <div
      className={classNames(
        styles.base,
        styles.variant[variant],
        className
      )}
      {...args}
    >
      {children}
    </div>
  )
}

export default Container
